import React from "react";
import { ExpandableCard } from "../../Commons/ExpandableCard/Expandablecard";
import { Paragraph } from "../../Commons/Paragraph";
import { Colors } from "../../Commons/Colors/Colors";
import EyeWhiteIcon from "../../../assets/imgs/eye-white-icon.svg";
import CalendarIcon from "../../../assets/imgs/calendar-checkmark.svg";
import LeafIcon from "../../../assets/imgs/LeafIcon.svg"; 
import RecapIcon from "../../../assets/imgs/recap-icon.svg"; 

const ResearchExpandCard = (props: any) => {
  const { title, subTitle, description } = props;

  const getTitleAndIcon = (key: string) => {
    switch (key) {
      case "seasonRecap":
        return { title: "Season Recap", icon: RecapIcon };
      case "seasonOutlook":
        return { title: "Season Outlook", icon: LeafIcon };
      case "weeklyRecap":
        return { title: "Weekly Recap", icon: EyeWhiteIcon };
      case "weeklyOutlook":
        return { title: "Weekly Outlook", icon: CalendarIcon };
      default:
        return { title: "", icon: null };
    }
  };

  const { title: formattedTitle, icon } = getTitleAndIcon(subTitle);

  const getTitle = (title: string) => {
    switch (title) {
      case "seasonRecap":
        return "Season Recap";
      case "seasonOutlook":
        return "Season Outlook";
      case "weeklyRecap":
        return "Weekly Recap";
      case "weeklyOutlook":
        return "Weekly Outlook";
      default:
        return "";
    }
  };

  return (
    <ExpandableCard
      cardBg={true}
      header={
        <>
          <div className="flex justify-between items-center w-full">
            <div
              className={`transition-colors duration-300 ease-in-out relative z-20 cursor-pointer w-full`}
            >
              <div className="flex justify-between w-full">
              <div className="flex items-center gap-2">
                <img src={icon} alt="" className="w-4 h-4" />

                <Paragraph
                  text={getTitle(subTitle)}
                  className="text-base !font-semibold"
                  ParagraphType="Pragragh22"
                  color="textPrimary"
                />
              </div>
              <Paragraph
                  text={"12h ago"}
                  className="text-[10px]"
                  ParagraphType="Pragragh22"
                  color="textPrimary"
                />
              </div>
              <Paragraph
                text={title}
                props={{ fontSize: "12px", fontWeight: 500 }}
                ParagraphType="Pragragh22"
                color="textPrimary"
                className="mt-6 w-[90%]"
              />
            </div>
          </div>
        </>
      }
    >
      <div className="mt-3">
        <Paragraph
          text={description}
          props={{
            fontSize: "12px",
            fontWeight: 500,
            color: Colors.textLigth,
          }}
          ParagraphType="Pragragh22"
          color="textPrimary"
        />
      </div>
    </ExpandableCard>
  );
};

export default ResearchExpandCard;
